import {
  MODELS_CLEAR_PAGINATION_INFO,
  MODELS_FETCH_MODELS,
  MODELS_SET_PAGE,
  MODELS_SET_ROWS_PER_PAGE,
} from '../action-types/models-types';
import AppConstants from '../../AppConstants';

const initialState = {
  entities: [],
  entity: {},
  entityLoaded: false,
  loading: false,
  paginationConfig: {
    total: 8,
    page: 1,
    rowsPerPage: AppConstants.rowsPerPage,
  },
};

export default function modelsReducer(state = initialState, action) {
  switch (action.type) {
    case MODELS_FETCH_MODELS.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MODELS_FETCH_MODELS.SUCCESS:
      return {
        ...state,
        entities: [...action.payload.data.models],
        paginationConfig: {
          ...state.paginationConfig,
          total: action.payload.total,
        },
        loading: false,
      };
    case MODELS_FETCH_MODELS.REJECTED:
      return {
        ...state,
        loading: false,
        entities: [],
      };

    case MODELS_SET_ROWS_PER_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          rowsPerPage: action.payload,
        },
      };
    case MODELS_SET_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          page: action.payload,
        },
      };
    case MODELS_CLEAR_PAGINATION_INFO:
      return {
        ...state,
        paginationConfig: {
          page: 1,
          rowsPerPage: AppConstants.rowsPerPage,
          total: 0,
        },
      };
    default:
      return state;
  }
}
